import { Button } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useNavigate, useParams } from 'react-router-dom'

import { ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'
import { HelperWrapper } from 'src/components'
import { useAccount } from 'src/hooks/accounts'
import { useMe } from 'src/hooks/users'
import { usePlanLimitNotofication } from '../plan-limits-nitification.hook'

export const useCreateUpgradeNotify = () => {
  const { enqueueSnackbar } = useSnackbar()
  const text = usePlanLimitNotofication()
  const { accountId } = useParams()
  const navigate = useNavigate()
  const { data: me } = useMe()
  const { data: account } = useAccount(me?.language.code)

  const handleClick = () => {
    navigate(joinAbsRoute(ROUTES.ACCOUNTS, accountId, `${ROUTES.ACCOUNT}?tab=billing`))
  }

  return function () {
    enqueueSnackbar(text({ limit: account?.subscription_plan }), {
      variant: 'error',
      action: (
        <Button color="inherit" onClick={handleClick}>
          <HelperWrapper t="upgrade-button-text" />
        </Button>
      ),
    })
  }
}
